import { Icons } from '@/components/icons';
import {
  defaultNumberFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  OutdoorAreaConfig,
  OutdoorSectionConfig,
  TenantConfig,
} from '@pigello/pigello-matrix';
import baseRevenueIncreaseFilters from '../contracts/components/base-revenue-increase-filters';
import baseFilters, {
  baseAddressFilters,
  baseBuildingFilter,
  baseGlobalRealEstatesFilter,
  baseSpaceFutureContractingFilters,
  baseSpaceStatusFilters,
  baseTagFilter,
} from '../filters';

const outdoorSectionFilters: Filter[] = [
  ...baseSpaceStatusFilters,
  ...baseSpaceFutureContractingFilters,
  ...baseBuildingFilter,
  ...baseGlobalRealEstatesFilter,
  {
    ...defaultRelationFilter,
    title: OutdoorSectionConfig.fields.outdoorArea.verboseName,
    externalFieldName:
      OutdoorSectionConfig.fields.outdoorArea.externalFieldName,
    relationModelName: OutdoorAreaConfig.modelName,
    icon: Icons.outdoorarea,
  },
  {
    ...defaultSelectFilter,
    title: OutdoorSectionConfig.fields.category.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.category.externalFieldName,
    choices: OutdoorSectionConfig.fields.category.choices,
  },
  {
    ...defaultStringFilter,
    title: OutdoorSectionConfig.fields.popularName.verboseName,
    externalFieldName:
      OutdoorSectionConfig.fields.popularName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: OutdoorSectionConfig.fields.landlordCustomId.verboseName,
    externalFieldName:
      OutdoorSectionConfig.fields.landlordCustomId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultStringFilter,
    title: OutdoorSectionConfig.fields.customId.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.customId.externalFieldName,
  },

  {
    ...defaultNumberFilter,
    title: OutdoorSectionConfig.fields.usableArea.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.usableArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: OutdoorSectionConfig.fields.biArea.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.biArea.externalFieldName,
  },

  {
    ...defaultRelationFilter,
    title: OutdoorSectionConfig.fields.tenant.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.tenant.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  {
    ...defaultRelationFilter,
    title: OutdoorSectionConfig.fields.biTenants.verboseName,
    externalFieldName: OutdoorSectionConfig.fields.biTenants.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  ...baseRevenueIncreaseFilters,
  ...baseAddressFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default outdoorSectionFilters;
